export const API_URL = "https://api.vidyamrutham.in/api";

//export const API_URL = "http://localhost:5000/api";
